<template>
	<div id="introduce-business-detail">
		<div class="header">
			<!--返回按键-->
			<div class="backImage" @click="backFun">
				<img src="../../assets/arrow.png" />
			</div>

			<!--图片-->
			<div class="backgroupImage">
				<img :src="item.thumbnail_url" />
			</div>

			<!--标题-->
			<div class="companyTitle">
				<div class="info">
					<div class="name">
						<span>{{ item.merchant_name }}</span>
						<van-tag style="margin-left: 1rem" type="warning">{{
							decodeURIComponent(this.$route.query.industryname)
						}}</van-tag>
					</div>
					<div class="concact">
						<div>联系电话:</div>
						<div class="phone">{{ item.merchant_phone }}</div>
					</div>
					<div class="location">
						<img src="../../assets/address.png" />
						<div class="address">{{ item.merchant_address }}</div>
					</div>
				</div>
			</div>
		</div>
		<!--内容-->
		<div class="content" v-html="item.content"></div>
	</div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
	data() {
		return {
			item: "",
			businessType: ""
		}
	},
	computed: {
		...mapGetters(["token", "userId", "communityId"])
	},
	created() {
		this.businessType = this.$route.query.industry_name
		this.vaxios.get(
			`${this.vaxios.host}/open/api/v1/merchants/${this.$route.query.id}/detail`,
			{},
			(res) => {
				if (res.code !== 1 || !res.data) return
				this.item = res.data
			},
			function (err) {
				console.log(err)
			},
			{
				headers: {
					Authorization: "Bearer " + this.token,
					"Content-Type": "application/json"
				}
			}
		)
	},
	methods: {
		backFun() {
			this.$router.go(-1)
		}
	}
}
</script>

<style>
#introduce-business-detail {
	display: flex;
	flex-direction: column;
	align-items: center;
}
#introduce-business-detail .header {
	width: 100%;
}

.backImage {
	height: 44px;
	width: 100%;
	display: flex;
	z-index: 20;
	position: absolute;
	margin-top: 0;
	align-items: center;
}

.backImage img {
	height: 50%;
	margin-left: 15px;
}

.backgroupImage img {
	height: 12.875rem;
	margin: 0 auto;
	display: block;
}

.companyTitle {
	position: relative;
	top: -45px;
	height: 8.75rem;
	margin-left: 11px;
	margin-right: 11px;
	background-color: white;
	border-radius: 0.43rem;
	box-shadow: 0px 1px 22px rgba(0, 0, 0, 0.05);
}

.info {
	padding-top: 24px;
	padding-left: 25px;
}

.name {
	line-height: 1.93rem;
	font-size: 1.37rem;
	font-weight: bold;
	color: rgba(0, 0, 0, 0.85);
	display: flex;
	align-items: center;
}

.concact {
	margin-top: 0.4rem;
	line-height: 1.03rem;
	color: rgba(0, 0, 0, 0.45);
	font-size: 0.85rem;
	display: flex;
}

.phone {
	margin-left: 10px;
}

.location {
	margin-top: 1.21rem;
	display: flex;
	align-items: center;
}

.location img {
	width: 1.25rem;
	height: 1.25rem;
}

.address {
	margin-left: 5px;
	line-height: 1.03rem;
	font-size: 0.85rem;
	color: rgba(0, 0, 0, 0.85);
}

.content {
	font-size: 16px;
	line-height: 32px;
	margin: 0 16px;
}
</style>
